import merge from 'lodash/merge';

const defaults = {};

const resolvers = merge({});

const typeDefs = [].join(' ');

export { defaults, resolvers, typeDefs };
